export default {
  data() {
    return {
      show: false,
      product: null,
    };
  },

  methods: {
    showNotifyMeModalCallback: showNotifyMeModalCallback,
    close: close,
  },

  mounted() {
    this.$eventBus.$on("show-notify-me-modal", this.showNotifyMeModalCallback);
  },

  beforeDestroy() {
    this.$eventBus.$off("show-notify-me-modal", this.showNotifyMeModalCallback);
  },
};

function showNotifyMeModalCallback(product) {
  this.product = product;
  this.show = true;
}

function close() {
  this.show = false;
}
